import { judeEnv } from "@/utils/util";
import Vue from "vue";
async function goMessage(a) {
  const environment = await judeEnv();
  if (environment.isFengChao) {
    if (a) {
      window.open(a);
    }
  } else {
    console.log(1);
    // Vue.prototype.$Message.error("请在智慧门户APP上打开");
  }
}
async function goServe(a,b,c,d) {
  console.log(a,b,c,d);
  const environment = await judeEnv();
  if (environment.isFengChao) {
    if (a) {
      window.open(a);
    }
  } else {
    // Vue.prototype.$Message.error("请在智慧门户APP上打开");
  }
}
async function goOfficialAccounts(a,b) {
  console.log(a,b);
  const environment = await judeEnv();
  if (environment.isFengChao) {
    // if () {
    //   window.open();
    // }
  } else {
    // Vue.prototype.$Message.error("请在智慧门户APP上打开");
  }
}
function messageImg(id) {
  console.log(1);
  let arr = document.getElementById(id)
  console.log(arr);
  arr.setAttribute("src",require('@/assets/zwx.png'));
  // arr.attr("src","/src/assets/zwx.png")
  console.log(arr,11111);
}
async function messageImg3(id) {
  console.log(id);
  setTimeout(() => {
    let arr = document.getElementById(id)
    console.log(arr);
    arr.addEventListener('onerror',function(){
      console.log('触发错误事件');
      arr.setAttribute("src",require('@/assets/zwx.png'));
    })
  });
  // let arr = await document.getElementById(id)

  // console.log(arr,11111);
}

export default {
  goMessage,
  goServe,
  goOfficialAccounts,
  messageImg,
  messageImg3
};
